module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Binocular-953a25bece52018cc7bf816ca04878e7.svg";